export default __webpack_public_path__ + "static/media/pics.0aa22736.png";